import request from "@/utils/request2";

//1、 获取图形验证码

export function getCaptcha(params) {
  return request({
    url: "/api/v1/captcha",
    method: "get",
    params,
  });
}

//2、 获取手机验证码

export function getRegistryCode(data) {
  return request({
    url: "/api/v1/registryCode",
    method: "post",
    data,
  });
}

//3、注册

export function setRegistry(data) {
  return request({
    url: "/api/v1/registry",
    method: "post",
    data,
  });
}

// 4、登录
export function setLogin(data) {
  return request({
    url: "/api/v1/login",
    method: "post",
    data,
  });
}

//5、账号信息
export function getAccount(params) {
  return request({
    url: "/api/v1/account",
    method: "get",
    params,
  });
}

//6、修改密码验证码
export function getPasswordCode(data) {
  return request({
    url: "/api/v1/passwordCode",
    method: "post",
    data,
  });
}

//7、忘记密码
export function getForgotPassword(data) {
  return request({
    url: "/api/v1/forgotPassword",
    method: "post",
    data,
  });
}

//7-1、修改密码
export function setChangePassword(data) {
  return request({
    url: "/api/v1/changePassword",
    method: "post",
    data,
  });
}

//8、上传头像
export function uploadAttachment(data) {
  return request({
    url: `/api/v1/avatar`,
    method: "post",
    data,
  });
}

//9、会员基础信息
export function getProfile(params) {
  return request({
    url: `/api/v1/profile`,
    method: "get",
    params,
  });
}

//9-1 、修改会员基础信息
export function setProfile(data) {
  return request({
    url: `/api/v1/profile/set`,
    method: "post",
    data,
  });
}

//10、省份
export function getProvinces(params) {
  return request({
    url: `/api/v1/provinces`,
    method: "get",
    params,
  });
}

//11、城市
export function getCities(params) {
  return request({
    url: `/api/v1/subCities`,
    method: "get",
    params,
  });
}

//12、区县
export function getDistricts(params) {
  return request({
    url: `/api/v1/subDistricts`,
    method: "get",
    params,
  });
}

// 13、签到记录
export function getSignedDays(params) {
  return request({
    url: `/api/v1/signedDays`,
    method: "get",
    params,
  });
}

//13-1、今日是否签到
export function getSigned(params) {
  return request({
    url: `/api/v1/signed`,
    method: "get",
    params,
  });
}

//13-2、签到
export function setSignin(data) {
  return request({
    url: `/api/v1/signin`,
    method: "post",
    data,
  });
}

// 14、历史任务参与记录
export function gethistoricalSurveys(params) {
  return request({
    url: `/api/v1/historicalSurveys`,
    method: "get",
    params,
  });
}

// 15、兑换记录
export function getOrders(params) {
  return request({
    url: `/api/v1/orders`,
    method: "get",
    params,
  });
}

// 16、积分汇总
export function getPointSummary(params) {
  return request({
    url: `/api/v1/pointSummary`,
    method: "get",
    params,
  });
}

//17、积分记录
export function getPoints(params) {
  return request({
    url: `/api/v1/points`,
    method: "get",
    params,
  });
}

// 18、邀请汇总
export function getRecommendationSummary(params) {
  return request({
    url: `/api/v1/recommendationSummary`,
    method: "get",
    params,
  });
}

//19、朋友
export function getFriends(params) {
  return request({
    url: `/api/v1/friends`,
    method: "get",
    params,
  });
}

//20、获取任务列表
export function getIndividualSurveys(params) {
  return request({
    url: `/api/v1/individualSurveys`,
    method: "get",
    params,
  });
}

//21、忽略问卷
export function setIgnoreSurvey(data) {
  return request({
    url: `/api/v1/ignoreSurvey`,
    method: "post",
    data,
  });
}

//22、问卷详情

export function getSurveysItem(data) {
  return request({
    url: `/api/v1/survey`,
    method: "post",
    data,
  });
}

// 23、获取支付宝信息
export function getAlipay(params) {
  return request({
    url: `/api/v1/alipay`,
    method: "get",
    params,
  });
}

//24、修改支付宝信息
export function setAlipay(data) {
  return request({
    url: `/api/v1/alipay/set`,
    method: "post",
    data,
  });
}

// 25、兑换奖品列表
export function getGifts(params) {
  return request({
    url: `/api/v1/gifts`,
    method: "get",
    params,
  });
}

//26、保存体现协议
export function setCashoutAgreement(data) {
  return request({
    url: `/api/v1/cashoutAgreement`,
    method: "post",
    data,
  });
}

// 27、兑换
export function setOrder(data) {
  return request({
    url: `/api/v1/order`,
    method: "post",
    data,
  });
}

//  28、活动
export function getActivities(params) {
  return request({
    url: `/api/v1/activities`,
    method: "get",
    params,
  });
}

//29、资讯
export function getNews(params) {
  return request({
    url: `/api/v1/news`,
    method: "get",
    params,
  });
}

export function getNewsItem(params) {
  return request({
    url: `/api/v1/news/${params.id}`,
    method: "get",
    params,
  });
}

//30、信用值
export function getCredits(params) {
  return request({
    url: `/api/v1/credits`,
    method: "get",
    params,
  });
}

//31、问题分类
export function getQuestionTypes(params) {
  return request({
    url: `/api/v1/questionTypes`,
    method: "get",
    params,
  });
}

//32、话题讨论
export function getForumSurveys(params) {
  return request({
    url: `/api/v1/forumSurveys`,
    method: "get",
    params,
  });
}

//33、积分类型
export function getPointTypeAll(params) {
  return request({
    url: `/api/v1/pointType/all`,
    method: "get",
    params,
  });
}

// 34、未读消息数量
export function getMessageCounts(params) {
  return request({
    url: `/api/v1/message/counts`,
    method: "get",
    params,
  });
}

//35、我的站内信
export function getMessages(params) {
  return request({
    url: `/api/v1/messages`,
    method: "get",
    params,
  });
}

//36、我的站内信
export function deleteMessages(data) {
  return request({
    url: `/api/v1/message/delete`,
    method: "delete",
    data,
  });
}

// 37、全部已读
export function getMessageRead(params) {
  return request({
    url: `/api/v1/message/read`,
    method: "get",
    params,
  });
}

//38、全部删除
export function clearMessage(params) {
  return request({
    url: `/api/v1/message/clear`,
    method: "delete",
    params,
  });
}


//39、已读
export function sendMessages(params) {
  return request({
    url: `/api/v1/messages/${params.id}`,
    method: "get",
    params,
  });
}

//40、问题
export function getQuestions(params) {
  return request({
    url: `/api/v1/questions`,
    method: "get",
    params,
  });
}

//41、奖品信息
export function getGiftsItem(params) {
  return request({
    url: `/api/v1/gifts/${params.id}`,
    method: "get",
    params,
  });
}


//41、婚姻状况
export function getMaritalStatus(params) {
  return request({
    url: `/api/v1/maritalStatus`,
    method: "get",
    params,
  });
}

//42、学历
export function getEducations(params) {
  return request({
    url: `/api/v1/educations`,
    method: "get",
    params,
  });
}

//43、工作状态
export function getWorkingStatus(params) {
  return request({
    url: `/api/v1/workingStatus`,
    method: "get",
    params,
  });
}

//44、收入
export function getIncomes(params) {
  return request({
    url: `/api/v1/incomes`,
    method: "get",
    params,
  });
}

//45、职位
export function getPositions(params) {
  return request({
    url: `/api/v1/positions`,
    method: "get",
    params,
  });
}

//46、汽车品牌
export function getVehicleBrands(params) {
  return request({
    url: `/api/v1/vehicleBrands`,
    method: "get",
    params,
  });
}

//47、汽车型号
export function getVehicleBrandsModels(params) {
  return request({
    url: `/api/v1/vehicleBrands/${params.id}/models`,
    method: "get",
    params,
  });
}


//48、患病
export function getDiseases(params) {
  return request({
    url: `/api/v1/diseases`,
    method: "get",
    params,
  });
}

//49、获取最新公告
export function getLatestNews(params) {
  return request({
    url: "/api/v1/news/latest",
    method: "get",
    params,
  });
}



//50、开始答卷
export function getsurveyTake(data) {
  return request({
    url: "/api/v1/survey/take",
    method: "post",
    data,
  });
}

//51、开始答卷
export function getExchangeHistory(params) {
  return request({
    url: "/api/v1/exchangeHistory",
    method: "get",
    params,
  });
}

//52、生成微信OAuth授权URL
export function getWeChatAuthWechatUrl(params) {
  return request({
    url: "/api/v1/WeChatAuth/wechat/url",
    method: "get",
    params,
  });
}
//自动登录
export function getWeChatCallback(data) {
  return request({
    url: "/api/v1/WeChatAuth/wechat/callback",
    method: "post",
    data,
  });
}

//53、签到问题
export function getSigninQuestions(params) {
  return request({
    url: "/api/v1/signinQuestions",
    method: "get",
    params,
  });
}


//回答问题
export function answerSigninQuestion(data) {
  return request({
    url: "/api/v1/signinQuestion/answer",
    method: "post",
    data,
  });
}


